function AuthModal({ filled, outlined, children }) {
  return (
    <div
      className={`${filled && "bg-blue text-white"}  ${
        outlined && "bg-white text-blue"
      } px-8 py-3 border-8 border-blue w-full md:w-5/12	 rounded-[50px]`}
    >
      {children}
    </div>
  );
}

export default AuthModal;
